import { createAction, props } from '@ngrx/store';
import { ISearchEmployeeResponse } from '../models/search-employees.model';

//store selected Employee details
export const loadSelectedEmployees = createAction('[SelectedEmployee] Load SelectedEmployees', props<{ selected: any }>());

//clear global search store
export const clearGlobalSearch = createAction('[ClearGlobalSearch] Clear Global Search Store');
